import React from "react";
import {BlockContainer, RTEWrapper} from "BaseComponents/Wrappers";

export const TextBlock = ({ Text }) => {
	return (
		<BlockContainer>
			<RTEWrapper
				dangerouslySetInnerHTML={{
					__html: Text,
				}}
			></RTEWrapper>
		</BlockContainer>
	);
};
